import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine class names safely. Use everywhere a className is constructed.
 * Example: <button className={cn('px-4 py-2', isPrimary && 'bg-brand-500')}>
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
